module.exports = __webpack_public_path__ + "img/programmer.3543aec4.png";